// assets
import { BulbOutlined, DashboardOutlined, BarChartOutlined, LockOutlined, TeamOutlined } from '@ant-design/icons';

// icons
const icons = {
  BulbOutlined,
  DashboardOutlined,
  BarChartOutlined,
  LockOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'gettingStarted',
      title: 'Getting started',
      type: 'item',
      url: process.env.REACT_APP_PYTHIA_API_URL + '/docs',
      icon: icons.BulbOutlined,
      breadcrumbs: false,
      target: true
    },
    {
      id: 'usage',
      title: 'Usage',
      type: 'item',
      url: '/',
      icon: icons.BarChartOutlined,
      breadcrumbs: false
    },
    {
      id: 'apiKeys',
      title: 'API keys',
      type: 'item',
      url: '/api-keys',
      icon: icons.LockOutlined,
      breadcrumbs: false
    },
    {
      id: 'members',
      title: 'Members',
      type: 'item',
      url: '/members',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
